"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RecommendationLocalLeisureResponseSchema = exports.RecommendationLocalAccommodationResponseSchema = exports.RecommendationLocalLeisureRequestSchema = exports.RecommendationLocalAccommodationRequestSchema = exports.RecommendedListHeaderSchema = void 0;
var zod_1 = require("zod");
var product_unit_1 = require("../product-unit");
exports.RecommendedListHeaderSchema = zod_1.z.object({
    type: zod_1.z.literal('RECOMMENDED_LIST_HEADER'),
    data: zod_1.z.object({
        title: zod_1.z.string(),
        subTitle: zod_1.z.string(),
        keyword: zod_1.z.string(),
    }),
});
exports.RecommendationLocalAccommodationRequestSchema = zod_1.z.object({
    recommendType: zod_1.z.union([zod_1.z.literal('LOCAL_ACCOMMODATION_SRP_NO_RESULT'), zod_1.z.literal('UNIVERSAL_SRP_NO_RESULT')]),
    checkInDate: zod_1.z.string(),
    checkOutDate: zod_1.z.string(),
    capacityAdults: zod_1.z.number(),
    childrenAges: zod_1.z.array(zod_1.z.number()),
    keyword: zod_1.z.string(),
});
exports.RecommendationLocalLeisureRequestSchema = zod_1.z.object({
    recommendType: zod_1.z.union([
        zod_1.z.literal('LOCAL_ACCOMMODATION_SRP'),
        zod_1.z.literal('LOCAL_LEISURE_SRP_NO_RESULT'),
        zod_1.z.literal('UNIVERSAL_SRP_NO_RESULT'),
    ]),
    keyword: zod_1.z.string(),
});
exports.RecommendationLocalAccommodationResponseSchema = zod_1.z.object({
    items: zod_1.z.array(zod_1.z.union([exports.RecommendedListHeaderSchema, product_unit_1.ProductUnitSchema])),
});
exports.RecommendationLocalLeisureResponseSchema = zod_1.z.object({
    items: zod_1.z.array(zod_1.z.union([exports.RecommendedListHeaderSchema, product_unit_1.ProductUnitSchema])),
});
